import Countries from './countries.json';

export const getCountryFullName = (countryCode: string) => {
  return Countries.countries.find((country) => country.value === countryCode)
    ?.label;
};

export const getCountryIcon = (CountryCode: string, ratio?: string) => {
  return `http://purecatamphetamine.github.io/country-flag-icons/${
    ratio ?? '3x2'
  }/${CountryCode}.svg`;
};

export { Countries };
